import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "./DateSelect.css";
import et from "date-fns/locale/et";
import LoadingScreen from '../../hoc/LoadingScreen';
import moment from 'moment';
import { Col, Form, Row } from 'react-bootstrap';
import parseDate from '../../util/parseDate';

const DateSelect = (props) => {

  const dateFilter = (date) => {
    if(props.includedDays.indexOf(date.getDay())===-1){
      return false;
    }

    if(props.disableHolidays){
      const tmpDate = moment(date);
      if(props.holidays.fixedDate.indexOf(tmpDate.format("MM-DD"))!==-1){
        return false;
      }
      if(props.holidays.movingDate.indexOf(tmpDate.format("Y-MM-DD"))!==-1){
        return false;
      }
    }

    
    return true;
  };

  return (
    <LoadingScreen isLoading={props.isLoading} text={props.loadingTxt}>
      <Row className="justify-content-md-center">
        <Col xs={12}>
          <Form>
            <Form.Group>
              <Form.Label><i className="fa fa-calendar-o"></i> Vali kuupäev</Form.Label>
              <Form.Group>
                <div className="datepicker-wrap">
                  <DatePicker
                    dateFormat="dd.mm.yyyy"
                    todayButton="Vali täna"
                    minDate={new Date()}
                    maxDate={moment().add(12, 'months').toDate()}
                    filterDate={dateFilter}
                    locale={et}
                    inline
                    selected={new Date(props.selectedDate)}
                    onChange={(date) => {
                      props.changed(parseDate(date));
                    }}
                  />
                </div>
              </Form.Group>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </LoadingScreen>
  );
};

export default DateSelect;